import styled from '@emotion/styled';
import { fontSize } from '@styles/globalStyles';
import { breakpoint } from '@styles/breakpoints';

export const Wrapper = styled.section`
  background-color: #f7f7f8;

  h3 {
    margin-top: 26px;
  }
`;

export const Container = styled.div`
  max-width: 860px;
  width: 100%;
  margin: 0 auto;
  padding: 50px 0;
  & img {
    margin: 40px 0 20px 0;
    width: 15%;
  }

  h3 {
    margin-top: 30px;
  }

  @media only screen and (max-width: 1350px) {
    padding: 25px 15px;
  }

  @media only screen and ${breakpoint.md} {
    & img {
      width: 50%;
    }
  }
`;

export const Description = styled.div`
  margin: 16px 0 32px 0;
  & p,
  span {
    font-size: ${fontSize(16)};
    line-height: 1.5;
    letter-spacing: -0.24px;
    color: #00202d;
  }

  ul,
  ol,
  .offer-ul {
    margin-top: 15px;
    margin-bottom: 40px;

    li {
      display: flex;
      align-items: flex-start;
      padding: 8px 0 8px 14px;
      position: relative;

      &::before {
        position: absolute;
        left: 0;
        content: '';
        width: 4px;
        height: 4px;
        border-radius: 100%;
        background-color: #e6007e;
        margin: 10px 10px 0 0;
      }
    }
  }
`;

export const Offers = styled.div`
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  gap: 32px;

  a {
    width: 50%;
    min-width: 300px;
  }
`;
